import { useState } from 'react';
import { Info, List } from 'lucide-react';
import './Card.css';
import './Popup.css';
import useNewFailures from '../../hooks/useNewFailures';
import GreatJobBadge from './GreatJobBadge';
import StatusBadge from './StatusBadge';

const NewFailuresCard = ({ selectedDate, selectedEnvironment, selectedPackage, selectedFramework, selectedIsCsqXp = null }) => {  
  const { data, loading, error } = useNewFailures(
    selectedDate,
    selectedEnvironment, 
    selectedPackage,
    selectedFramework,
    selectedIsCsqXp
  );

  const [isPopupOpen, setPopupOpen] = useState(false);

  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);
  };

  if (loading)     
    return (
      <div className="empty-card">
      <div className="metric-header">
        <h2 style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            New failures
            <span className="tooltip-wrapper">
              <Info size={14} color="#888" />
              <span className="tooltip-text">New failures are test cases that did not fail in the previous date range at all, but are failing in the current date range</span>
            </span>
          </h2>
        <StatusBadge status="loading" label="Loading" />
      </div>
      <div className="metric-value loading flashing" style={{height: '80%'}}></div>
    </div>
  );

  if (error) 
    return (
      <div className="empty-card">
      <div className="metric-header">
        <h2 style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            New failures
            <span className="tooltip-wrapper">
              <Info size={14} color="#888" />
              <span className="tooltip-text">New failures are test cases that did not fail in the previous date range at all, but are failing in the current date range</span>
            </span>
          </h2>
        <StatusBadge status="error" label="Error" />
      </div>
      <div className="metric-value error flashing" style={{height: '80%'}}></div>
    </div>
  );

  if (data.length === 0)
    return (
      <div className="empty-card">
      <div className="metric-header">
        <h2 style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            New failures
            <span className="tooltip-wrapper">
              <Info size={14} color="#888" />
              <span className="tooltip-text">New failures are test cases that did not fail in the previous date range at all, but are failing in the current date range</span>
            </span>
          </h2>
        <StatusBadge status="improved" label="Improved" />
      </div>
      <div className="metric-value">{data.length} new failures</div>
      <div className="metric-comparison">
        <span className="comparison-period"> "vs. previous day"</span>
      </div>
      <GreatJobBadge message="Nothing new is breaking." />
    </div>
  );

  if (data) 
    return (
    <div className="empty-card">
      <div className="metric-header">
        <h2 style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            New failures
            <span className="tooltip-wrapper">
              <Info size={14} color="#888" />
              <span className="tooltip-text">New failures are test cases that did not fail in the previous date range at all, but are failing in the current date range</span>
            </span>
          </h2>
        <StatusBadge status="monitor" label="To monitor" />
      </div>
      <div className="metric-value">{data.length} new failures</div>
      <div className="metric-comparison">
        <span className="comparison-period"> "vs. previous day"</span>
      </div>
      <p className="metric-description">There are {data.length} new failures since yesterday. Click here to see details.</p>
      
      <div className="view-list-button">
        <button onClick={togglePopup} className="view-details-button">
          <List size={20} className="list-icon" />
          View list
        </button>
      </div>
      
      {isPopupOpen && (
        <>
          <div className="overlay" />
          <div className="popup" >
            <button onClick={togglePopup} className="close-button">×</button>
            <h3>List of new failed tests</h3>
            <div className="popup-content">
              <table className="failures-table">
                <thead>
                  <tr>
                    <th className="table-header">Test Name</th>
                    <th className="table-header">Package Name</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((failure, index) => (
                    <tr key={index} className="table-row">
                      <td className="table-cell">{failure.testName}</td>
                      <td className="table-cell">{failure.packageName}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default NewFailuresCard; 